<template>
    <div>
        <b-nav tabs v-bind:class="classObject">
            <b-nav-item v-ripple v-on:click="switchPage('Start')">
                <font-awesome-icon :icon="['fas', 'home']" />
            </b-nav-item>
            <b-nav-item v-ripple v-on:click="switchPage('Overview')">
                <font-awesome-icon :icon="['fas', 'bars']" />
            </b-nav-item>
            <b-nav-item v-ripple v-on:click="switchPage('Docs')">
                <font-awesome-icon :icon="['fas', 'book-open']" />
            </b-nav-item>

            <b-nav-item>
            </b-nav-item>

            <b-nav-item>
            </b-nav-item>
        </b-nav>
    </div>
</template>

<style lang="scss">
    .nav-tabs {

        border-bottom: 0px solid transparent;
        position: fixed;
        bottom: 50px;
        left: 50px;
        right: 50px;
        height: 100px;
        border-radius: 70px;
        background-color: #1b212b;
        overflow:hidden;
        transition: all 0.2s ease-out;

        .nav-item {
            margin-bottom: -1px;
            height: 100%;
            width:20%;

            .nav-link {
                border: 0px solid transparent;
                height: 100%;
                line-height: 80px;
                font-size: 30px;
                color: #fff;
            }
        }

        &.scrolling {
            bottom: -130px;
        }
    }
</style>

<script>

    import Start from "./Start";
    import Overview from "./Overview";
    import Docs from "./Docs";

    var questionBox = {
        name: "menuHeader",
        data: function(){
            return {
                types: [],
                isActive: false
            }
        },
        created: function () {

        },
        computed: {
            classObject: function () {
                window.console.log(this.$parent.isActive);
                return {
                    scrolling: this.$parent.isActive
                }
            }
        },
        methods: {
            switchPage(componentName){
                let componentBox = Start;
                switch(componentName){
                    case "Start":
                        componentBox = Start;
                        break;
                    case "Overview":
                        componentBox = Overview;
                        break;
                    case "Docs":
                        componentBox = Docs;
                        break;
                }
                this.$parent.component = componentBox;
            }
        }
    };
    export default questionBox;
</script>